import React from "react";
import { useNavigate } from "react-router-dom";
import ShareIcon from "@mui/icons-material/Share";
import { Box, Card, IconButton, Typography, CardContent } from "@mui/material";

const BlogCards = ({
  blogTitle,
  blogImage,
  blogHeading,
  blogDescription,
  blogCreatedDate,
  blogId,
}) => {
  const navigate = useNavigate();

  // Only show ribbon for the first two cards (id === 0 or id === 1)
  let ribbonLabel = null;
  if (typeof blogId === "number") {
    ribbonLabel = blogId === 0 ? "New" : blogId === 1 ? "New" : null;
  }

  // Card content (with all fields optional)
  const cardContent = (
    <Card elevation={2} sx={BlogCardStyles.BlogParentCardContainer}>
      {/* Blog Title (optional) */}
      {/* {blogTitle && (
        <Box sx={BlogCardStyles.BlogTitle}>{blogTitle}</Box>
      )} */}

      {/* Blog Image (optional) */}
      {blogImage && (
        <Box
          component="img"
          src={blogImage}
          alt="Blog Visual"
          sx={BlogCardStyles.BlogImages}
        />
      )}

      <CardContent align="justify" sx={{}}>
        {/* Blog Heading (optional) */}
        {blogHeading && (
          <Typography
            gutterBottom
            variant="body1"
            sx={BlogCardStyles.BlogHeadingTxt}
          >
            {blogHeading}
          </Typography>
        )}

        {/* Blog Description (optional) */}
        {blogDescription && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={BlogCardStyles.BlogDescriptionTxt}
          >
            {blogDescription}
          </Typography>
        )}

        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Blog Created Date (optional) */}
          {blogCreatedDate ? (
            <Typography
              variant="caption"
              sx={BlogCardStyles.BlogCreatedDateTxt}
            >
              {blogCreatedDate}
            </Typography>
          ) : (
            <span />
          )}

          <IconButton size="small" color="primary">
            <ShareIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box
      mt={1}
      onClick={() =>
        // navigate(`/blogs-details${blogId !== undefined ? `/${blogId}` : ""}`)
        navigate(`/blogs-details?blogid=${blogId}&blog-name=${blogHeading}`)
      }
      sx={{ cursor: "pointer", position: "relative" }}
    >
      {ribbonLabel && <Box sx={BlogCardStyles.Ribbon}>{ribbonLabel}</Box>}
      {cardContent}
    </Box>
  );
};

export default BlogCards;

// Blogs
const BlogCardStyles = {
  BlogParentCardContainer: {
    border: "1px solid #e5e7eb",
    boxShadow: "none",
    borderRadius: 3,
    overflow: "visible",
    position: "relative",
    width: { xs: "315px", sm: "555px", md: "533px", lg: "350px" },
    "&:hover": {
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
    },
  },
  BlogTitle: {
    position: "absolute",
    top: -12,
    right: 16,
    backgroundColor: "var(--color-primary-dark)",
    color: "#fff",
    px: 2,
    py: 1,
    borderRadius: "0 6px 0 6px",
    fontSize: 12,
    fontWeight: 500,
    zIndex: 0,
    fontFamily: '"Poppins", serif',
    maxWidth: "70%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  BlogImages: {
    width: "100%",
    height: 200,
    objectFit: "cover",
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
  },
  BlogHeadingTxt: { fontWeight: 600, fontFamily: '"Poppins", serif' },
  BlogDescriptionTxt: {
    mb: 2,
    height: 100,
    overflow: "hidden",
    fontFamily: '"Poppins", serif',
  },
  BlogCreatedDateTxt: {
    fontWeight: 500,
    color: "#0056D2",
    fontFamily: '"Poppins", serif',
  },
  Ribbon: {
    width: 60,
    fontSize: 14,
    padding: "4px",
    position: "absolute",
    left: -19,
    top: -12,
    textAlign: "center",
    borderRadius: "25px",
    transform: "rotate(-20deg)",
    backgroundColor: "#ff9800",
    color: "white",
    zIndex: 1,
    fontWeight: 600,
    fontFamily: '"Poppins", sans-serif',
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
    letterSpacing: 0.5,
    lineHeight: 1.5,
    display: "inline-block",
    pointerEvents: "none",
    userSelect: "none",
  },
};
